export const CHECK_API_CONNECTIVITY = 'CHECK_API_CONNECTIVITY';
export const CHECK_API_CONNECTIVITY_SUCCEEDED = 'CHECK_API_CONNECTIVITY_SUCCEEDED';
export const CHECK_API_CONNECTIVITY_FAILED = 'CHECK_API_CONNECTIVITY_FAILED';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCEEDED = 'USER_LOGIN_SUCCEEDED';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';

export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCEEDED = 'USER_LOGOUT_SUCCEEDED';
export const USER_LOGOUT_FAILED = 'USER_LOGOUT_FAILED';

export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';

export const FAST_LOGIN_CHECK_EMAIL = 'FAST_LOGIN_CHECK_EMAIL';
export const FAST_LOGIN_CHECK_EMAIL_SUCCEEDED = 'FAST_LOGIN_CHECK_EMAIL_SUCCEEDED';
export const FAST_LOGIN_CHECK_EMAIL_FAILED = 'FAST_LOGIN_CHECK_EMAIL_FAILED';

export const FAST_LOGIN_VERIFY_OTP = 'FAST_LOGIN_VERIFY_OTP';
export const FAST_LOGIN_VERIFY_OTP_SUCCEEDED = 'FAST_LOGIN_VERIFY_OTP_SUCCEEDED';
export const FAST_LOGIN_VERIFY_OTP_FAILED = 'FAST_LOGIN_VERIFY_OTP_FAILED';

export const FAST_LOGIN_RESET = 'FAST_LOGIN_RESET';
export const FAST_LOGIN_UPDATE_STRUCTURE = 'FAST_LOGIN_UPDATE_STRUCTURE';